import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import classes from "./Cartsidebar.module.css";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import times from "../../../assets/cartimgs/times.svg";
import {
  addTocart,
  decreamentQuantity,
  increamentQuantity,
} from "../../redux/productSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AuthContext from "../authContext";

export default function CartSidebar({ toggle, isOpen }) {
  const currency = useSelector(
    (state) => state.products.selectedCurrency[0].currency
  );
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const productData = useSelector((state) => state.products.productData);
  const [totalAmt, setTotalAmt] = React.useState("");
  const dispatch = useDispatch();
  
  const [isLoading, setIsLoading] = React.useState(false);
  const authCtx = React.useContext(AuthContext);
  const [localQuantities, setLocalQuantities] = React.useState({});
  const navigate = useNavigate();
  

  React.useEffect(() => {
    const initialQuantities = productData.reduce((acc, item) => {
      acc[item._id] = item.quantity;
      return acc;
    }, {});
    setLocalQuantities(initialQuantities);
  }, [productData]);

  const handleInputChange = (id, value, maxQuantity) => {
    // Ensure only numeric values are parsed
    let numericValue = parseInt(value.replace(/\D/g, ''), 10) || 1; // Remove non-numeric characters
    let adjustedValue = Math.max(1, Math.min(maxQuantity, numericValue));
  
    // If the value exceeds maxQuantity, show a toast message
    if (adjustedValue > maxQuantity) {
      // Uncomment this for toast notifications
      // toast.info(
      //   language === "eng"
      //     ? "No more items in stock"
      //     : "Plus d'articles en stock",
      //   {
      //     position: "top-right",
      //     autoClose: 1500,
      //     hideProgressBar: true,
      //     theme: "colored",
      //   }
      // );
    }

    setLocalQuantities((prev) => ({
      ...prev,
      [id]: adjustedValue,
    }));
  };

  const updateQuantity = (item) => {
    if (!isLoading) {
    const newQuantity = localQuantities[item._id];
    if (newQuantity !== item.quantity) {
    setIsLoading(true)
      axios
        .put(`${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`, {
          quantity: newQuantity,
        })
        .then(() => {
          dispatch(
            addTocart({
              _id: item._id,
              title: item.name,
              author: item.author,
              image: item.image,
              price: item.price,
              quantity: newQuantity - item.quantity, // The difference in quantities
              description: item.resume,
            })
          );
        })
        .catch(() => {
          toast.error(
            language === "eng"
              ? "Failed to update item quantity."
              : "Échec de la mise à jour de la quantité.",
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              theme: "colored",
            }
          );
        }).finally(
          setTimeout(() => {
            setIsLoading(false);
          }, 1000)
        );
    }

    }
  };

  const handleKeyPress = (e, item) => {
    if (e.key === "Enter" || e.key === "Tab") {
      updateQuantity(item);
    }
  };

  const handleBlur = (item) => {
    updateQuantity(item);
  };
 

  // React.useEffect(() => { 
  //   let totalPrice = 0;
  //   productData.forEach((item) => {
  //     // Skip the item if _qte_a_terme_calcule is less than 1
  //     if (item._qte_a_terme_calcule < 1) {
  //       return;
  //     }
  
  //     // Calculate the price considering the discount
  //     const price = (item.discount > 0
  //       ? (item.price - item.price * (item.discount / 100))
  //       : Number(item.price)) * 1;
  
  //     totalPrice += item.quantity * price;
  //   });
  
  
    
  //   if (currency === "usd") {
  //     // Convert both totalPrice and totalTVA to USD
  //     const convertedTotalPrice = totalPrice * authCtx.currencyRate;
      
  //     setTotalAmt(convertedTotalPrice);
  //   } else {
  //     // For EUR, keep the original values
  //     setTotalAmt(totalPrice);
  //     }
  // }, [productData, currency]);

  
  React.useEffect(() => {  
    let totalPrice = 0;
    let totalTVA = 0;
    let totalPricedollar = 0;
    let totalTVAdollar = 0;
  
    productData.forEach((item) => {
      // Skip the item if _qte_a_terme_calcule is less than 1
      if (item._qte_a_terme_calcule < 1) {
        return;
      }
  
      // Calculate the price considering the discount
      const discountedPrice = item.discount > 0
        ? (item.price - (item.price * (item.discount / 100))).toFixed(2)
        : Number(item.price).toFixed(2);
      const price = discountedPrice ;
      const priceTTC = item.price_ttc;
      const priceNet = item.price * 1;

      // Calculate the cost and TVA
      const cost = price - (priceTTC - priceNet);
      const tva = item.discount > 0
        ? (priceTTC - priceNet) - ((priceTTC - priceNet) * (item.discount / 100))
        : priceTTC - priceNet;
  
      totalPrice +=  (price * 1).toFixed(2) * item.quantity;
      totalTVA += (tva * 1).toFixed(2) * item.quantity;
      totalPricedollar +=  (price * authCtx.currencyRate).toFixed(2) * item.quantity;
      totalTVAdollar += (Number(tva).toFixed(2) * authCtx.currencyRate).toFixed(2) * item.quantity;
    });
  
  
    if (currency === "usd") {
      const sum = (totalPricedollar + totalTVAdollar);
      
      // For EUR, keep the original values
      setTotalAmt(Number(sum).toFixed(2));
    } else {
      const sum = (totalPrice + totalTVA);
      // For EUR, keep the original values
      setTotalAmt(Number(sum));
      }
  }, [productData, currency]);

  const list = (anchor) => (
    <>
      <Box
        role="presentation"
        //   onClick={toggle}
        // onKeyDown={toggle}
        className={classes.container}
      >
        <List style={{ background: "#fff" }}>
          <ListItem disablePadding>
            {/* <ListItemButton> */}
            <ListItemText
              style={{
                textAlign: "start",
                padding: "0 3%",
              }}
            >
              <div className={classes.header}>
                <h1
                  style={{ fontSize: "calc(0.8vw + 0.5rem)", display: "flex" }}
                >
                  {language === "eng" ? "You bought" : "Vous avez ajouté"} {productData?.length}{language === "eng" ? " items" : " articles"}
                </h1>
                <h1
                  style={{ fontSize: "calc(0.8vw + 0.7rem)", display: "flex" }}
                >
                  <span style={{ fontWeight: 600 }}>
                    {" "}
                    {currency === "eur"
                      ? `${(totalAmt * 1).toFixed(2)}€`
                      : `${(totalAmt * authCtx.currencyRate).toFixed(2)}$`}
                  </span>
                  <span style={{ margin: "-5% 1.4em 0 auto" ,cursor:"pointer"}}>
                    <img src={times} alt="" onClick={toggle} />
                  </span>
                </h1>
                {/* <h3>{productData ? `Your cart has ${productData.length} items` : ''}</h3> */}
                {/* <h3>
                  {language === "eng"
                    ? "you have €88 left to benefit from FREE delivery"
                    : "il vous reste 88€ pour profiter de la livraison GRATUITE"}
                </h3> */}
              </div>
            </ListItemText>
            {/* </ListItemButton> */}
          </ListItem>
        </List>
        <div className={classes.margin}>
          {productData?.map((props) => {
            return (
              <List>
                <ListItem disablePadding>
                  {/* <ListItemButton> */}
                  <ListItemText
                    style={{
                      textAlign: "center",
                      padding: "0 3%",
                    }}
                  >
                    <div className={classes.card} key={props._id} style={{  position:'relative',overflow:'hidden'}} >
                      {props?.removed && <div className={classes.removed_item}>
                        <p>{language === "eng" ? "NOT AVAILABLE ANYMORE!" : "N'EST PLUS DISPONIBLE !"}</p>
                      </div>} 
                      <div style={{ margin: "10%" ,position:'relative'}}>
                     {props._qte_a_terme_calcule < 1 && <div style={{cursor:'pointer'}} className={classes.out_of_stock}>
                        <p>{language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}</p>
                      </div>}
                        <img src={props.image} alt="" width="100%" style={{width:"100%",height:'90%'}}/>
                      </div>
                      <div>
                        <div className={classes.carddata}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              rowGap: ".1em",
                              textAlign: "start",
                            }}
                          >
                            <p className={classes.font_size}>{props.title?.slice(0,20)}{props.title?.length >20 && '...'}</p>
                            <p className={classes.font_size}>{props?.author}</p>
                            <p className={classes.font_size}>
                              ISBN {props._code_barre}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr",
                              rowGap: ".2em",
                              textAlign: "start",
                            }}
                          >
                            <p></p>
                            <p className={classes.font_size} style={{fontWeight:"600"}}>
                              {language === "eng" ? "price" : "prix"}:{" "}
                              {currency === "eur"
                            ? `${
                                props.discount > 0
                                  ? (
                                      props.price_ttc -
                                      props.price_ttc * (props.discount / 100)
                                    ).toFixed(2)
                                  : Number(props.price_ttc).toFixed(2)
                              }€`
                            : `${
                                props.discount > 0
                                  ? (
                                      (props.price_ttc -
                                        props.price_ttc *
                                          (props.discount / 100)) *
                                      authCtx.currencyRate
                                    ).toFixed(2)
                                  : (
                                      props.price_ttc * authCtx.currencyRate
                                    ).toFixed(2)
                              }$`}{" "}   {props.discount > 0 && <span
                                style={{
                                  color: "var(--primary-color)",
                                  textDecoration: "line-through",
                                  fontSize: "meduim",
                                  margin:'0'
                                }}
                              >
                                {currency === "eur"
                                  ? ` ${Number(props.price_ttc).toFixed(2)}€`
                                  : ` ${(
                                      props.price_ttc * authCtx.currencyRate
                                    ).toFixed(2)}$`}
                              </span>}     
                            </p>
                            <p className={classes.font_size} style={{fontWeight:"600"}}>
                               total:{" "}
                               {currency === "eur"
  ? ` ${(props.quantity * (props.discount > 0
      ? parseFloat((props.price_ttc - props.price_ttc * (props.discount / 100)).toFixed(2))
      : (Number(props.price_ttc))).toFixed(2)).toFixed(2)}€`
  : `${(props.discount > 0
      ? ((props.price_ttc - props.price_ttc * (props.discount / 100)) * authCtx.currencyRate).toFixed(2) * props.quantity
      : (props.price_ttc * authCtx.currencyRate) * props.quantity).toFixed(2)}$`}
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: "0em",
                            marginBottom: "1em",
                          }}
                        >
                          {props._qte_a_terme_calcule > 0 ?
                          <div style={{display:"flex",flexDirection:'column',margin:"auto",width:"100%"}}>
                          <div className={classes.quantity}>
                          <p
                            style={{
                              color: "#fff",
                              fontWeight: 500,
                              margin: "auto",
                              fontSize: "calc(1rem + 0.5vw)",
                              cursor: isLoading ? "wait" : 'pointer',
                            }}
                            onClick={() => {
                              if (props.quantity != 1) {
                                if (!isLoading) {
                                  setIsLoading(true);
                                const item = productData.find(
                                  (item) => item._id === props._id
                                );
                                const newQuantity = props.quantity - 1;
                                axios
                                  .put(
                                    `${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`,
                                    {
                                      quantity: newQuantity,
                                    }
                                  )
                                  .then((response) => {
                                    // console.log("PUT request successful:", response.data);
                                    dispatch(
                                      decreamentQuantity({
                                        _id: props._id,
                                        title: props.name,
                                        author: props.author,
                                        image: props.image,
                                        price: props.price,
                                        quantity: 1,
                                        description: props.resume,
                                      })
                                    );
                                  })
                                  .catch((error) => {
                                    // console.error("Error in PUT request:", error);
                                    toast.error(`${language === 'eng' ? "Failed to remove item from cart." : "Échec de la suppression de l'article du panier."}`, {
                                      position: "top-right",
                                      autoClose: 1500,
                                      hideProgressBar: true,
                                      closeOnClick: true,
                                      pauseOnHover: true,
                                      draggable: true,
                                      progress: 0,
                                      theme: "colored",
                                    });
                                  }).finally(
                                    setTimeout(() => {
                                      setIsLoading(false);
                                    }, 1000)
                                  );
                                }
                              } else {
                                // setShowPopup(props._id)
                                // authCtx.deleteFromcart(props._id);
                              }
                            }}
                          >
                            -
                          </p>
                          <p
                            style={{
                              color: "#fff",
                              fontWeight: 500,
                              fontSize: "calc(0.7rem + 0.3vw)",
                              margin: "auto",
                            }}
                          >
                            <input
                            type="number"
                            value={localQuantities[props._id] || ""}
                            onChange={(e) =>
                              handleInputChange(props._id, e.target.value, props._qte_a_terme_calcule)
                            }
                            onBlur={() => handleBlur(props)} // Trigger when leaving input
                            onKeyPress={(e) => handleKeyPress(e, props)} // Trigger when pressing Enter or Tab
                            style={{
                                color: "#fff",
                                fontWeight: 500,
                                fontSize: "20px",
                                margin: "auto",
                                width: "50px",
                                textAlign: "center",
                                backgroundColor: "transparent",
                                border: "none",
                                outline: "none",
                              }}
                            />
                          </p>
                          <p
                            style={{
                              color: "#fff",
                              fontWeight: 500,
                              margin: "auto",
                              fontSize: "calc(1rem + 0.5vw)",
                              cursor: Number(props.quantity)  >= Number(props._qte_a_terme_calcule) ? 'not-allowed' : isLoading ? "wait" : 'pointer',
                              opacity: Number(props.quantity)  >= Number(props._qte_a_terme_calcule) ? '0.3' : '1',
                            }}
                            onClick={() => {
                              const item = productData.find(
                                (item) => item._id === props._id
                              );
                              if (Number(item.quantity)  < Number(item._qte_a_terme_calcule)) {
                                if (!isLoading) {
                                  setIsLoading(true);
                              const newQuantity = props.quantity + 1;
                              axios
                                .put(
                                  `${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`,
                                  {
                                    quantity: newQuantity,
                                  }
                                )
                                .then((response) => {
                                  // console.log("PUT request successful:", response.data);
                                  dispatch(
                                    increamentQuantity({
                                      _id: props._id,
                                      title: props.name,
                                      author: props.author,
                                      image: props.image,
                                      price: props.price,
                                      quantity: 1,
                                      description: props.resume,
                                    })
                                  );
                                })
                                .catch((error) => {
                                  // console.error("Error in PUT request:", error);
                                  toast.error(`${language === 'eng' ? "Failed to add item to cart." : "Échec de l'ajout d'un article au panier."}`, {
                                    position: "top-right",
                                    autoClose: 1500,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: 0,
                                    theme: "colored",
                                  });
                                }).finally(
                                  setTimeout(() => {
                                    setIsLoading(false);
                                  }, 1000)
                                );
                              }
                              }
                            }}
                          >
                            +
                          </p>
                        </div><p style={{ margin: "1em 0 0 0",textAlign:'start',color:props._qte_a_terme_calcule > 0 ? "#2DB224" : "#EE5858",fontWeight:"600" }}>{props._qte_a_terme_calcule > 0 ? `${(props._qte_a_terme_calcule * 1).toFixed(0)} ${language === "eng" ? "in stock" : "en stock"}` : `${language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}`} </p>
                          </div> : <div/>}
                          <div style={{ margin: "auto",zIndex:'50' }}>
                            <DeleteIcon
                              style={{
                                color: props?.removed ? "rgb(255, 66, 66)" : "var(--primary-color)",
                                cursor: "pointer",
                              }}
                              onClick={() => authCtx.deleteFromcart(props._id)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </ListItemText>
                  {/* </ListItemButton> */}
                </ListItem>
              </List>
            );
          })}
        </div>
        <List>
          <ListItem disablePadding>
            {/* <ListItemButton> */}
            <ListItemText
              style={{
                textAlign: "start",
              }}
            >
              <div className={classes.btn_con}>
                <button
                  className={classes.btn}
                  onClick={() => navigate(`/cart`) & toggle()}
                >
                  {language === "eng" ? "Place the order" : "Passer la commande"}
                </button>
              </div>
            </ListItemText>
            {/* </ListItemButton> */}
          </ListItem>
        </List>
      </Box>
    </>
  );

  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer anchor={anchor} open={isOpen} onClose={toggle}>
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
